import { FormPayload as OrganizationFormPayload } from 'components/SubscriptionOrganizationForm/interfaces';
import { FormPayload as SubscriptionSettingsFormPayload } from 'components/SubscriptionSettingsForm/interfaces';
import { createContext } from 'react';
import { ModuleTypes } from 'enums';

export interface SubscriptionContextProps {
  selectedModules: ModuleTypes[];
  userCount: number;
  organizationForm: OrganizationFormPayload;
  settingsForm: SubscriptionSettingsFormPayload;
  setUserCount: (userCount: number) => void;
  toggleModule: (module: ModuleTypes) => void;
  setOrganizationForm: (organizationForm: OrganizationFormPayload) => void;
  setSettingsForm: (settingsForm: SubscriptionSettingsFormPayload) => void;
  handleNextStep: () => void;
}

export const SubscriptionContext = createContext<
  SubscriptionContextProps | undefined
>(undefined);
